





















import _ from 'lodash'
import moment from 'moment'
import { Provide, Prop, Component } from 'vue-property-decorator'
import { BaseForm } from '@/services/BaseForm'
import { IFormOption, INPUT_TYPES } from '@/components/form/FieldTypes'
import RuleHelper from '@/utils/RuleHelper'
import { Getter, Action } from 'vuex-class'
import { IJob, IJobType } from '@/store/modules/views/job/states'
import { IPatient, IPatientType } from '@/store/modules/views/patient/states'
import { countSunday } from '@/utils/DateHelper'
import { IMonthlyContract } from '@/store/modules/views/monthlyContract/states'
import { TCountCaregiver } from '@/store/modules/views/caregiver/actions'

@Component
export default class EditJobDialog extends BaseForm<any> {
  @Provide('formName') public formName = 'jobDialog'
  @Prop({ default: '' }) private status!: string
  @Prop() private open!: boolean
  @Prop() private callback!: () => void
  @Prop() private job!: IJob & { roles: string[], permissions: string[], accounts: string[] }

  private loading = false
  private options: OptionTable = {
    page: 1,
    sortBy: ['name'],
    sortDesc: [false],
    itemsPerPage: 99999,
    search: '',
  }
  private hasMonthlyContract: boolean | null = null
  private countCaregiver: TCountCaregiver

  @Getter('patient/patientOptions')
  private patientOptions!: [{ text: string, value: any, userId: string }]

  @Getter('patient/patientLists')
  private patientLists!: IPatient[]

  @Getter('components/level')
  private level!: {
    id?: string,
    mode: string,
  }

  @Getter('center/centerLists')
  private centerLists!: Array<{
      text?: string,
      value?: string,
  }>

  // @Getter('patient/centerId')
  // private centerId!: (patientType: string) => string

  @Getter('patient/userId')
  private userId!: (patientType: string) => string

  @Getter('patient/patientId')
  private patientId!: (patientType: string) => string

  @Getter('patient/patientTypeById')
  private patientTypeById!: {[patientTypeId: string]: IPatientType}

  @Getter('job/jobType')
  private jobType!: (patientTypeId: string) => [{ jobTypeId: string, text: string, period: string[] }]

  @Getter('job/periodLists')
  private periodLists!: (jobType: {period: string[]}) => [{ text: string, value: any }]

  @Getter('workingTime/startWorkingTimeLists')
  private startWorkingTimeLists!: (
    patientTypeId: string, jobType: string, period: string, time: IJob['time'], index: number,
  ) => [{ text: string, value: any }]

  @Getter('workingTime/endWorkingTimeLists')
  private endWorkingTimeLists!: (
    patientTypeId: string, jobType: string, period: string, time: IJob['time'], index: number, startTime: string,
  ) => [{ text: string, value: any }]

  @Getter('workingTime/priceWorkingTimeLists')
  private priceWorkingTimeLists!: (
    patientTypeId: string, jobType: string, period: string, startTime: string, endTime: string,
  ) => [{ text: string, value: any }]

  get totalDate() {
    if (this.dataStore.startDate && this.dataStore.endDate) {
      return (
        moment(this.dataStore.endDate).diff(moment(this.dataStore.startDate), 'days') + 1
      ) - ((this.dataStore.excludeDate && this.dataStore.excludeDate.length) || 0)
    }
    return 0
  }

  get formDefault(): any {
    return this.doConvertIntToString(this.job)
  }

  get dataStore() {
    return this.getByName(this.formName)
  }

  get jobTypeOptions() {
    const data = this.dataStore || this.formDefault
    return this.jobType(
      (data.patient && data.patient.patientTypeId)
      || (
        data.patientType && _.find(this.patientTypeById, (patientType) => patientType.name === data.patientType)._id
      ) || '',
    )
  }

  get jobTypeId() {
    const type = this.dataStore.type || this.formDefault.type
    return type && type.jobTypeId
  }

  get editJobDialogOption() {
    return {
      justify: 'start',
      form: this.$refs.form && this.openDialog ? this.$refs.form : {},
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          notValidate: true,
          height: '30',
        },
        saveDraftButton: {
          title: 'บันทึกแบบร่าง',
          action: this.saveDraft,
          loading: this.loading,
          height: '30',
          color: 'primary',
          outlined: true,
          notValidate: true,
        },
        submitButton: {
          title: 'แก้ไขและส่งหาผู้รับบริการ',
          action: this.submitData,
          loading: this.loading,
          height: '30',
          color: 'primary',
        },
      },
    }
  }

  get jobForm(): IFormOption[] {
    const isGroup = this.dataStore && _.includes(this.dataStore.period, 'กะ')
    const fieldPriceDetail = this.dataStore && this.dataStore.fields && this.dataStore.fields.priceDetail
    const centerId = this.level.id || (this.dataStore && this.dataStore.centerId)
    return [
      {
        type: INPUT_TYPES.AUTOCOMPLETE,
        col: '12',
        props: {
          name: 'patient',
          label: 'ผู้สูงอายุ/ผู้ป่วย',
          placeholder: 'เลือกผู้สูงอายุ/ผู้ป่วย',
          loading: this.loading,
          defaultValue: this.formDefault && this.formDefault.patientId
            ? _.find(this.patientOptions, {_id: this.formDefault.patientId})
            : undefined,
          isRequired: true,
          returnObject: true,
          rules: [RuleHelper.required],
          options: this.patientOptions,
          on: {
            change: (value) => {
              // reset type
              if (this.dataStore && this.dataStore.period) {
                this.doResetDataStore(
                  ['type', 'period', 'time'],
                  this.startWorkingTimeLists(
                    value
                      ? value.patientTypeId
                      : this.dataStore.patientTypeId,
                    this.dataStore.type.jobTypeId,
                    this.dataStore.period,
                    this.dataStore.time,
                    0,
                  ),
                )
              }
              if (centerId && this.dataStore.startDate && this.dataStore.endDate) {
                this.getMonthlyContract(
                  centerId,
                  value._id,
                  this.dataStore.startDate,
                  this.dataStore.endDate,
                )
              }
            },
          },
        },
      },
      {
        type: INPUT_TYPES.AUTOCOMPLETE,
        col: '12',
        props: {
          name: 'centerId',
          label: 'ศูนย์บริการ',
          placeholder: 'เลือกศูนย์บริการ',
          loading: this.loading,
          isRequired: true,
          isHide: this.level.mode !== 'all',
          rules: [RuleHelper.required],
          options: this.centerLists,
          defaultValue: this.formDefault && this.formDefault.centerId,
          on: {
            change: (value) => {
              if (this.dataStore.patient && this.dataStore.startDate && this.dataStore.endDate) {
                this.getMonthlyContract(
                  value,
                  this.dataStore.patient._id,
                  this.dataStore.startDate,
                  this.dataStore.endDate,
                )

                this.getCountCaregivers(
                  value, this.dataStore.startDate, this.dataStore.endDate, this.dataStore.excludeDate
                )
              }
            },
          },
        },
      },
      {
        type: INPUT_TYPES.AUTOCOMPLETE,
        col: '12',
        props: {
          name: 'type',
          label: 'ประเภทบริการ',
          placeholder: 'เลือกประเภทบริการ',
          parent: 'patient',
          defaultValue: this.formDefault && this.formDefault.type
            ? _.find(this.jobTypeOptions, (option) => option.text === this.formDefault.type)
            : undefined,
          loading: this.loading,
          returnObject: true,
          isRequired: true,
          disabled: !(this.dataStore && this.dataStore.patient),
          rules: [RuleHelper.required],
          options: this.jobTypeOptions,
          on: {
            change: (value) => {
              // reset period
              if (this.dataStore && this.dataStore.period) {
                this.doResetDataStore(
                  ['period', 'time'],
                  this.startWorkingTimeLists(
                    this.dataStore.patient
                      ? this.dataStore.patient.patientTypeId
                      : this.dataStore.patientTypeId,
                    value.jobTypeId,
                    this.dataStore.period,
                    this.dataStore.time,
                    0,
                  ),
                )
              }
            },
          },
        },
      },
      {
        type: INPUT_TYPES.SELECT,
        col: '12',
        props: {
          name: 'period',
          label: 'ช่วงเวลา',
          placeholder: 'เลือกช่วงเวลา',
          parent: 'type',
          loading: this.loading,
          isRequired: true,
          disabled: !(this.dataStore && this.dataStore.type),
          defaultValue: this.formDefault && this.formDefault.period
            ? this.formDefault.period
            : undefined,
          rules: [RuleHelper.required],
          options: this.dataStore.type
            ? this.periodLists(this.dataStore.type)
            : this.formDefault.type
            ? this.periodLists(
                _.find(this.jobTypeOptions, (option) => option.text === this.formDefault.type),
              )
            : [],
          on: {
            change: (value) => {
              // reset time
              if (this.dataStore && value) {
                this.doResetDataStore(
                  ['time'],
                  this.startWorkingTimeLists(
                    this.dataStore.patient
                      ? this.dataStore.patient.patientTypeId
                      : this.dataStore.patientTypeId,
                    this.dataStore.type.jobTypeId,
                    value,
                    this.dataStore.time,
                    0,
                  ),
                )
                if (this.dataStore.startDate) {
                  setTimeout(() => this.filterExcludeDate(this.dataStore.startDate, 'startDate'), 100)
                }
              }
            },
          },
        },
      },
      {
        type: INPUT_TYPES.DATE,
        col: '6',
        props: {
          name: 'startDate',
          label: 'วันที่เริ่ม',
          placeholder: 'เลือกวันที่',
          parent: 'type',
          loading: this.loading,
          isRequired: true,
          rules: [RuleHelper.required, RuleHelper.date],
          allowDate: (date) => moment(date).diff(moment(), 'days') > -1,
            // && (this.dataStore.endDate
            //   ? moment(date).diff(moment(this.dataStore.endDate), 'days') < 1
            //   : true
            // ),
          defaultValue: this.formDefault && this.formDefault.startDate
            ? this.formDefault.startDate
            : undefined,
          on: {
            change: this.filterExcludeDate,
          },
        },
      },
      {
        type: INPUT_TYPES.DATE,
        col: '6',
        props: {
          name: 'endDate',
          label: 'วันที่สิ้นสุด',
          placeholder: 'เลือกวันที่',
          parent: 'startDate',
          disabled: !(this.dataStore && this.dataStore.startDate),
          loading: this.loading,
          isRequired: true,
          isHide: this.dataStore && _.includes(this.dataStore.period, 'เดือน'),
          rules: [RuleHelper.required, RuleHelper.date],
          allowDate: (date) => moment(date).diff(moment(this.dataStore.startDate), 'days') > -1,
          defaultValue: this.formDefault && this.formDefault.endDate
            ? this.formDefault.endDate
            : undefined,
          on: {
            change: this.filterExcludeDate,
          },
        },
      },
      {
        type: INPUT_TYPES.DATE,
        col: '12',
        props: {
          name: 'excludeDate',
          label: 'วันที่ไม่รับบริการ',
          placeholder: 'เลือกวันที่',
          loading: this.loading,
          parent: 'endDate',
          disabled: !(this.dataStore && this.dataStore.endDate),
          multiple: true,
          hideDetail: true,
          defaultValue: this.formDefault && this.formDefault.excludeDate
            ? this.formDefault.excludeDate
            : undefined,
          allowDate: (date) => (
            (moment(date).diff(moment(this.dataStore.startDate), 'days', true) > 0) &&
            (moment(this.dataStore.endDate).diff(moment(date), 'days', true) > 0)
          ),
          rules: [RuleHelper.required, RuleHelper.date],
          on: {
            change: (value, name) => {
              this.getCountCaregivers(
                this.dataStore.centerId, this.dataStore.startDate, this.dataStore.endDate, value
              )
              this.$store.dispatch(
                'form/updateAttr',
                {
                  formName: this.formName,
                  attrName: name,
                  value: value.sort(),
                },
              )
            },
          },
        },
      },
      {
        type: INPUT_TYPES.DESCRIPTION,
        col: '12',
        props: {
          title: `วันทำงาน ${this.totalDate} วัน หยุด ${this.dataStore.excludeDate && this.dataStore.excludeDate.length || 0} วัน`,
          className: 'mb-2',
        },
      },
      {
        type: INPUT_TYPES.DESCRIPTION,
        col: '12',
        props: {
          title: this.countCaregiver ? `นักบริบาลทั้งหมด: ${this.countCaregiver.total} คน โดนแบน: ${this.countCaregiver.banned} คน พร้อมรับงาน: ${this.countCaregiver.availableMax} คน`: "",
          className: 'mb-4',
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: 'ตารางเวลา และค่าใช้จ่าย',
          className: 'font-weight-bold',
        },
      },
      {
        type: INPUT_TYPES.GROUP,
        col: '12',
        props: {
          name: 'time',
          className: 'frame-group',
          isAction: isGroup,
          options: this.doMapDefaultOptions([{
            fields: [
              {
                type: INPUT_TYPES.SELECT,
                col: '3',
                props: {
                  name: 'time[0].startTime',
                  label: 'เวลาเริ่มปฏิบัติงาน',
                  placeholder: 'เลือกเวลาเริ่มปฏิบัติงาน',
                  defaultValue: this.formDefault &&
                    this.formDefault.time &&
                    this.formDefault.time[0] &&
                    this.formDefault.time[0].startTime
                      ? this.formDefault.time[0].startTime
                      : undefined,
                  parent: 'period',
                  loading: this.loading,
                  isRequired: true,
                  isHideDetail: true,
                  disabled: !(this.dataStore && this.dataStore.period),
                  rules: [RuleHelper.required],
                  options: this.formDefault && this.formDefault.period
                    ? this.startWorkingTimeLists(
                        this.dataStore.patient
                          ? this.dataStore.patient.patientTypeId
                          : this.dataStore.patientTypeId,
                        this.jobTypeId,
                        this.dataStore.period,
                        this.dataStore.time,
                        0,
                      )
                    : [],
                },
              },
              {
                type: INPUT_TYPES.SELECT,
                col: '3',
                props: {
                  name: 'time[0].endTime',
                  label: 'เวลาสิ้นสุดปฏิบัติงาน',
                  placeholder: 'เลือกเวลาสิ้นสุดปฏิบัติงาน',
                  defaultValue: this.formDefault &&
                    this.formDefault.time &&
                    this.formDefault.time[0] &&
                    this.formDefault.time[0].endTime
                      ? this.formDefault.time[0].endTime
                      : undefined,
                  parent: 'period',
                  loading: this.loading,
                  isHideDetail: true,
                  isRequired: true,
                  disabled: !(this.dataStore && this.dataStore.period),
                  rules: [RuleHelper.required],
                  options: this.dataStore &&
                    this.dataStore.period &&
                    this.dataStore.time &&
                    this.dataStore.time[0] &&
                    this.dataStore.time[0].startTime
                      ? this.endWorkingTimeLists(
                          this.dataStore.patient
                            ? this.dataStore.patient.patientTypeId
                            : this.dataStore.patientTypeId,
                          this.jobTypeId,
                          this.dataStore.period,
                          this.dataStore.time,
                          0,
                          this.dataStore.time[0].startTime,
                        )
                      : [],
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '3',
                props: {
                  name: 'time[0].people',
                  label: 'จำนวนคน',
                  disabled: !(this.formDefault && this.formDefault.type),
                  defaultValue: this.formDefault &&
                    this.formDefault.time &&
                    this.formDefault.time[0] &&
                    this.formDefault.time[0].people
                      ? this.formDefault.time[0].people
                      : undefined,
                  isHideDetail: true,
                  isRequired: true,
                  rules: [RuleHelper.required, RuleHelper.number],
                },
              },
              {
                type: INPUT_TYPES.SELECT,
                col: '3',
                props: {
                  name: 'time[0].workingTime',
                  label: 'ราคาการใช้บริการ',
                  placeholder: 'เลือกราคาการใช้บริการ',
                  defaultValue: this.formDefault &&
                    this.formDefault.time &&
                    this.formDefault.time[0]
                      ? _.pick(this.formDefault.time[0], ['price', 'food'])
                      : undefined,
                  parent: 'time',
                  loading: this.loading,
                  isRequired: true,
                  isHideDetail: true,
                  disabled: !(
                    this.formDefault.time && this.formDefault.time[0] &&
                    this.formDefault.time[0].startTime && this.formDefault.time[0].endTime
                  ),
                  rules: [RuleHelper.required],
                  options: this.formDefault.time &&
                    this.formDefault.time[0] &&
                    this.formDefault.time[0].startTime &&
                    this.formDefault.time[0].endTime &&
                    this.formDefault.type &&
                    this.formDefault.type.period
                    ? this.priceWorkingTimeLists(
                        this.dataStore.patient
                          ? this.dataStore.patient.patientTypeId
                          : this.dataStore.patientTypeId,
                        this.jobTypeId,
                        this.formDefault.type.period,
                        this.formDefault.time[0].startTime,
                        this.formDefault.time[0].endTime,
                      )
                    : [],
                },
              },
            ],
          }]),
        },
      },
      // {
      //   type: INPUT_TYPES.TEXT,
      //   col: '4',
      //   props: {
      //     name: 'contractPrice',
      //     label: 'ค่าทำสัญญา',
      //     defaultValue: this.formDefault && this.formDefault.contractPrice
      //       ? this.formDefault.contractPrice
      //       : '0',
      //     rules: [RuleHelper.currency],
      //   },
      // },
      // {
      //   type: INPUT_TYPES.TEXT,
      //   col: '4',
      //   props: {
      //     name: 'insurancePrice',
      //     label: 'ค่าประกันล่วงหน้า',
      //     defaultValue: this.formDefault && this.formDefault.insurancePrice
      //       ? this.formDefault.insurancePrice
      //       : '0',
      //     rules: [RuleHelper.currency],
      //   },
      // },
      // {
      //   type: INPUT_TYPES.TEXT,
      //   col: '4',
      //   props: {
      //     name: 'caregiverPrice',
      //     label: 'ค่าจัดส่งนักบริบาล',
      //     defaultValue: this.formDefault && this.formDefault.caregiverPrice
      //       ? this.formDefault.caregiverPrice
      //       : '0',
      //     rules: [RuleHelper.currency],
      //   },
      // },
      // {
      //   type: INPUT_TYPES.TEXT,
      //   col: '3',
      //   props: {
      //     name: 'foodPrice',
      //     label: 'ค่าอาหาร',
      //     defaultValue: this.formDefault && this.formDefault.foodPrice
      //       ? this.formDefault.foodPrice
      //       : '0',
      //     rules: [RuleHelper.currency],
      //   },
      // },
      {
        type: INPUT_TYPES.SWITCHTOGGLE,
        col: '3',
        props: {
          name: 'isPriceDetail',
          label: 'ค่าใช้จ่ายอื่นๆ',
          className: 'ml-1',
          defaultValue: this.formDefault && this.formDefault.isPriceDetail
              ? this.formDefault.isPriceDetail
              : false,
        },
      },
      {
        type: INPUT_TYPES.GROUP,
        col: '12',
        props: {
          name: 'priceDetail',
          className: 'frame-group',
          isHide: this.dataStore && this.dataStore.isPriceDetail
            ? !this.dataStore.isPriceDetail
            : true,
          isAction: true,
          defaultValue: this.formDefault && this.formDefault.priceDetail && this.formDefault.priceDetail.length > 0
            ? this.formDefault.priceDetail
            : null,
          options: fieldPriceDetail ? fieldPriceDetail : [{
            fields: [
              {
                type: INPUT_TYPES.TEXT,
                col: '12',
                props: {
                  name: 'priceDetail[0].text',
                  label: 'รายละเอียด',
                  prefix: '1.',
                  defaultValue: this.formDefault &&
                    this.formDefault.priceDetail &&
                    this.formDefault.priceDetail[0] &&
                    this.formDefault.priceDetail[0].text
                      ? this.formDefault.priceDetail[0].text
                      : undefined,
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '3',
                props: {
                  name: 'priceDetail[0].price',
                  label: 'ราคา',
                  defaultValue: this.formDefault &&
                    this.formDefault.priceDetail &&
                    this.formDefault.priceDetail[0] &&
                    this.formDefault.priceDetail[0].price
                      ? this.formDefault.priceDetail[0].price
                      : undefined,
                  rules: [RuleHelper.currency],
                },
              },
              {
                type: INPUT_TYPES.SELECT,
                col: '3',
                props: {
                  name: 'priceDetail[0].unit',
                  label: 'หน่วย',
                  defaultValue: this.formDefault &&
                    this.formDefault.priceDetail &&
                    this.formDefault.priceDetail[0] &&
                    this.formDefault.priceDetail[0].unit
                      ? this.formDefault.priceDetail[0].unit
                      : undefined,
                  options: [
                    { text: 'ทั้งหมด', value: 'ทั้งหมด' },
                    { text: 'ต่อวัน', value: 'ต่อวัน' },
                  ],
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '3',
                props: {
                  name: 'priceDetail[0].caregiver',
                  label: 'ส่วนของนักบริบาล',
                  suffix: '%',
                  defaultValue: this.formDefault &&
                    this.formDefault.priceDetail &&
                    this.formDefault.priceDetail[0] &&
                    this.formDefault.priceDetail[0].caregiver
                      ? this.formDefault.priceDetail[0].caregiver
                      : '0',
                  rules: [RuleHelper.number, RuleHelper.percent],
                  on: {
                    change: (data, name) => {
                      this.doAssignPercentValue(this.jobForm, name, data, 'center')
                    },
                  },
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '3',
                props: {
                  name: 'priceDetail[0].center',
                  label: 'ส่วนของศูนย์บริการ',
                  suffix: '%',
                  defaultValue: this.formDefault &&
                    this.formDefault.priceDetail &&
                    this.formDefault.priceDetail[0] &&
                    this.formDefault.priceDetail[0].center
                      ? this.formDefault.priceDetail[0].center
                      : '0',
                  rules: [RuleHelper.number, RuleHelper.percent],
                  on: {
                    change: (data, name) => {
                      this.doAssignPercentValue(this.jobForm, name, data, 'caregiver')
                    },
                  },
                },
              },
            ],
          }],
        },
      },
    ]
  }

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  @Action('patient/getPatientList')
    private getPatientList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('patient/getPatientTypeList')
  private getPatientTypeList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('workingTime/getWorkingTimeList')
  private getWorkingTimeList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('job/putJob')
  private putJob!: (options) => void

  @Action('monthlyContract/getMonthlyContracts')
  private getMonthlyContracts!: (headerParams: any) => Promise<IMonthlyContract[]>

  @Action('caregiver/getCountCaregiver')
  private getCountCaregiver!: (headerParams: any) => Promise<TCountCaregiver>

  private async getCountCaregivers(centerId: string, startDate: string, endDate: string, excludeDate: string[]) {
    this.countCaregiver = await this.getCountCaregiver({
      centerId, startDate, endDate, excludeDate
    })
  }

  private async getMonthlyContract(centerId: string, patientId: string, startDate: string, endDate: string) {
    this.hasMonthlyContract = null
    const [contracts] = await Promise.all([
      this.getMonthlyContracts({ headers: { filter: {
        centerId: [{condition: 'is', value: centerId}],
        patientId: [{condition: 'is', value: patientId}],
        endDate: [{
          condition: 'greater than equal',
          value: startDate,
        }],
        startDate: [{
          condition: 'less than equal',
          value: moment(endDate).add(3, 'month').format('YYYY-MM-DD'),
        }],
      } } }),
      // this.getCountCaregiver({centerId, startDate, endDate})
    ])
    // this.countCaregiver = countCaregiver
    this.hasMonthlyContract = !_.isEmpty(contracts)
  }

  private filterExcludeDate(value, name) {
    this.dataStore[name] = value
    const startDate = moment(this.dataStore.startDate)
    let endDate = moment(this.dataStore.endDate)

    if (name === 'startDate') {
      if (_.includes(this.dataStore.period, 'เดือน')) {
        endDate = startDate.clone().add(1, 'month').subtract(1, 'day')
        this.$store.dispatch(
          'form/updateAttr',
          {
            formName: this.formName,
            attrName: 'endDate',
            value: endDate.format('YYYY-MM-DD'),
          },
        )
      } else if (endDate.diff(startDate, 'day', true) < 0) {
        this.$store.dispatch(
          'form/updateAttr',
          {
            formName: this.formName,
            attrName: 'endDate',
            value: '',
          },
        )
      }
    }
    if (endDate.diff(startDate, 'day', true) >= 30) {
      this.getMonthlyContract(
        this.dataStore.centerId,
        this.dataStore.patient._id,
        startDate.format('YYYY-MM-DD'),
        endDate.format('YYYY-MM-DD'),
      )
    } else {
      this.hasMonthlyContract = null
    }
    let excludeDate = _.filter(
      this.dataStore.excludeDate,
      (date) => moment(date).isBetween(startDate, endDate, null, '()'),
    )
    if (_.includes(this.dataStore.period, 'เดือน')) {
      excludeDate = _.uniq(_.concat(excludeDate, countSunday(startDate, endDate)))
    }
    this.getCountCaregivers(
      this.dataStore.centerId, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'), excludeDate
    )

    this.$store.dispatch(
      'form/updateAttr',
      {
        formName: this.formName,
        attrName: 'excludeDate',
        value: excludeDate,
      },
    )
  }

  private async mounted() {
    await Promise.all([
      this.getPatient(),
      this.getPatientType(),
      this.getWorkingTime(),
    ])
  }

  private async getList(lists, filter = {}) {
    this.loading = true
    await lists({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify(filter)).toString('base64'),
      },
    })
    this.loading = false
  }

  private async getPatient() {
    this.getList(this.getPatientList, {patientTypeId: [{
      condition: 'exists',
      value: true,
    }]})
  }

  private async getPatientType() {
    this.getList(this.getPatientTypeList)
  }

  private async getWorkingTime() {
    this.getList(this.getWorkingTimeList)
  }

  private doMapDefaultOptions(fields) {
    const arrFileds = []
    // Add Item
    if (
      (
        this.dataStore &&
        this.dataStore.fields &&
        this.dataStore.fields.time &&
        this.dataStore.fields.time.length
      ) >
      (this.dataStore && this.dataStore.time && this.dataStore.time.length)
    ) {
      const lengthTime = this.dataStore.time.length
      const startTimeList = this.startWorkingTimeLists(
        this.dataStore.patient
          ? this.dataStore.patient.patientTypeId
          : this.dataStore.patientTypeId,
        this.jobTypeId,
        this.dataStore.period,
        this.dataStore.time,
        lengthTime,
      )
      this.$store.dispatch(
        'form/updateAttr',
        {
          formName: this.formName,
          attrName: 'time',
          value: _.concat(
            this.dataStore.time, [{
              startTime: _.head(startTimeList).value,
              endTime: '',
              people: 1,
              price: 0,
            }],
          ),
        },
      )
    }

    // Get Data Form Default (Init) Or Store (Update)
    let currentTimeData = this.dataStore && this.dataStore.time
      ? this.dataStore.time
      : (this.formDefault && this.formDefault.time ? this.formDefault.time : undefined)
    if (
      this.dataStore &&
      this.dataStore.period &&
      !_.includes(this.dataStore.period, 'กะ') &&
      (this.dataStore.fields.time.length > 1 || this.dataStore.time.length > 1)
    ) {
      currentTimeData = _.filter(currentTimeData, (item, index: number) => index === 0)
      this.$store.dispatch(
        'form/updateAttr',
        {
          formName: this.formName,
          attrName: 'time',
          value: currentTimeData,
        },
      )
      this.$store.dispatch(
        'form/updateAttr',
        {
          formName: this.formName,
          attrName: 'fields',
          value: { time: _.filter(this.dataStore.fields.time, (item, index: number) => index === 0) },
        },
      )
    }
    const time = this.dataStore && this.dataStore.time
    if (currentTimeData && currentTimeData.length > 0) {
      _.forEach(currentTimeData, (item, index: number) => {
        const currentFields = this.dataStore && this.dataStore.fields
          ? this.dataStore.fields.time[index].fields
          : fields[0].fields
        arrFileds.push({
          fields: _.map(currentFields, (field) => {
            // tslint:disable-next-line:no-unnecessary-initializer
            let defaultValue = undefined
            let disabled = !(this.dataStore && this.dataStore.type)
            let options = field.props.options ? field.props.options : undefined
            const split = _.split(field.props.name, '.')
            if (_.includes(field.props.name, 'startTime') && this.dataStore.type) {
              disabled = !(this.dataStore && this.dataStore.period)
              options = this.startWorkingTimeLists(
                this.dataStore.patient
                  ? this.dataStore.patient.patientTypeId
                  : this.dataStore.patientTypeId,
                this.dataStore.type.jobTypeId,
                this.dataStore.period,
                this.dataStore.time,
                index,
              )
            } else if (_.includes(field.props.name, 'endTime') && this.dataStore.type) {
              disabled = !(this.dataStore && this.dataStore.period)
              options = this.endWorkingTimeLists(
                this.dataStore.patient
                  ? this.dataStore.patient.patientTypeId
                  : this.dataStore.patientTypeId,
                this.dataStore.type.jobTypeId,
                this.dataStore.period,
                this.dataStore.time,
                index,
                item.startTime,
              )
            } else if (_.includes(field.props.name, 'workingTime') && this.dataStore.type) {
              disabled = !(time && time[index] && time[index].startTime && time[index].endTime)
              options = this.priceWorkingTimeLists(
                this.dataStore.patient
                  ? this.dataStore.patient.patientTypeId
                  : this.dataStore.patientTypeId,
                this.dataStore.type.jobTypeId,
                this.dataStore.period,
                item.startTime,
                item.endTime,
              )
            }
            defaultValue = item[split[1]]
            return {
              ...field,
              props: {
                ...field.props,
                name: `${split[0].substring(0, split[0].length - 3)}[${index}].${split[1]}`,
                options,
                defaultValue,
                disabled,
              },
            }
          }),
        })
      })

      // Assign Fields Data Store (Default)
      if (_.isUndefined(this.dataStore.fields)) {
        const key = 'time'
        this.$store.dispatch(
          'form/updateAttr',
          {
            formName: this.formName,
            attrName: 'fields',
            value: { [key]: arrFileds },
          },
        )
      }

      // Assign Vuelue Data Store (Default)
      if (_.isUndefined(this.dataStore.time)) {
        this.$store.dispatch(
          'form/updateAttr',
          {
            formName: this.formName,
            attrName: 'time',
            value: this.formDefault.time,
          },
        )
      }
      return arrFileds
    }
    return fields
  }

  private doAssignPercentValue(forms, name, data, key) {
    const diff = data && !_.isEmpty(data) ? 100 - _.toInteger(data) : 0
    const filedName = `${_.split(name, '.')[0]}.${key}`
    _.forEach(forms, (item: IFormOption) => {
      if (item.props.options) {
        _.forEach(item.props.options, (subitem: { fields: IFormOption }) => {
          if (subitem.fields) {
            _.forEach(subitem.fields, (field: IFormOption) => {
              if (field.props.name === filedName) {
                field.props.defaultValue = (diff < 0) || (diff >= 100) ? 0 : _.toString(diff)
                this.$store.dispatch(
                  'form/updateAttr',
                  {
                    formName: this.formName,
                    attrName: filedName,
                    value: field.props.defaultValue,
                  },
                )
              }
            })
          }
        })
      }
    })
  }

  private doResetDataStore(names, optionStartTime: Array<{ text: string, value: any }>) {
    _.forEach(names, (name) => {
      this.$store.dispatch(
        'form/updateAttr',
        {
          formName: this.formName,
          attrName: name,
          value: name === 'time'
            ? _.includes(this.dataStore.time, 'กะ')
              ? _.map(this.dataStore.time, () => {
                  return { startTime: _.head(optionStartTime).value }
                })
              : [{ startTime: _.head(optionStartTime).value }]
            : null,
        },
      )
    })
  }

  private async submitData() {
    this.callApi('รอชำระเงิน', 'บันทึกข้อมูล และส่งหาผู้ใช้สำเร็จ')
  }

  private async saveDraft() {
    this.callApi('แบบร่าง', 'บันทึกแบบร่างสำเร็จ')
  }

  private async callApi(status, alert) {
    this.loading = true
    let data = {
      ...this.dataStore,
      _id: this.job._id,
      type: this.dataStore.type.text,
      status,
      centerId: this.dataStore.centerId || (this.dataStore.patient ? this.dataStore.patient.centerId : ''),
      userId: this.dataStore.patient.userId,
      patientId: this.dataStore.patient._id,
      patientType: this.patientTypeById[(
        this.dataStore.patient
          ? this.dataStore.patient.patientTypeId
          : this.dataStore.patientTypeId
      )].name,
      time: _.map(this.dataStore.time, (time) => {
        return {
          ..._.omit(time, ['workingTime']),
          people: time.people ? time.people : 1,
          price: time.workingTime ? time.workingTime.price : '',
          food: time.workingTime ? time.workingTime.food : '',
        }
      }),
    }
    data = this.doConvertStringToInt(data)
    try {
      await this.putJob(data)
      this.updateSnackbar({txt: alert, type: 'success'})
      await this.callback()
      this.closeDialog()
    } catch (error) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
